import parse from 'html-react-parser';
import { FC } from 'react';
import style from './PrivacyPolicyStyle.module.css';
import { RoundSheet } from '@/components/uiParts/Sheet/RoundSheet/RoundSheet';

interface PrivacyPolicyProps {
  html?: string;
}
export const PrivacyPolicy: FC<PrivacyPolicyProps> = ({ html }) => {
  if (!html) return <></>;
  return (
    <RoundSheet>
      <div className={style['container']}>{parse(html)}</div>
    </RoundSheet>
  );
};
